import createCachedSelector from 're-reselect';
import {RootState} from '../../rootReducer';

const getAllBuildingResources = (state: RootState) => state.data.buildingResources;

export const getBuildingResources = (state: RootState, buildingId: string) =>
  getAllBuildingResources(state).resourcesByBuildingId[buildingId];

export const getBuildingResourceById = createCachedSelector(
  (_state: RootState, _buildingId: string, resourceId: string) => resourceId,
  getBuildingResources,
  (resourceId, resourcesByBuildingId) => resourcesByBuildingId?.resources?.find((r) => r.id === resourceId),
)((_state: RootState, buildingId: string, resourceId: string) => `${buildingId}:${resourceId}`);
